export const arrow = {
    x0: 10,
    x1: 55,
    y1: 50,
    x2: 60,
    y2: 45,
    x3: 20,
};
